import { useMemo } from 'react';
import { useRemoteAppConfigQuery } from 'shared/hooks/queries/use-remote-app-config-query';

export const useMetricTemplates = () => {
  const { data } = useRemoteAppConfigQuery();

  return useMemo(() => data ?? [], [data]);
};
